import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreateSchedule, Schedule, ScheduleListResponse, ScheduleQueryParams, UpdateSchedule } from '@frontend/report/types';

export class ScheduleClient extends APIClient {
    public static readonly endpoint = '/report-api/v1';

    public static async fetchSchedules(queryParams?: ApiQueryParams<ScheduleQueryParams>): Promise<ScheduleListResponse> {
        return await this.apiPaginated<ScheduleListResponse, ScheduleQueryParams>(`${this.endpoint}/schedules`, queryParams);
    }

    public static async resolveSchedules(ids: string[], field: keyof Schedule = 'id'): Promise<ScheduleListResponse> {
        const response = await this.post(`${this.endpoint}/schedules-resolve`, { field, ids: ids });
        return await this.handleResponse<ScheduleListResponse>(response);
    }

    public static async deleteSchedules(scheduleIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/schedules-delete`, { ids: scheduleIds });
        return await this.handleVoidResponse(response);
    }

    public static async postSchedule(accountId: string, reportId: string, schedule: CreateSchedule): Promise<Schedule> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/schedules`, schedule);
        return await this.handleResponse<Schedule>(response);
    }

    public static async fetchSchedule(accountId: string, reportId: string, scheduleId: string): Promise<Schedule> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/schedules/${scheduleId}`);
        return await this.handleResponse<Schedule>(response);
    }

    public static async patchSchedule(accountId: string, reportId: string, scheduleId: string, schedule: UpdateSchedule): Promise<Schedule> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/schedules/${scheduleId}`, schedule);
        return await this.handleResponse<Schedule>(response);
    }

    public static async deleteSchedule(accountId: string, reportId: string, scheduleId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/reports/${reportId}/schedules/${scheduleId}`);
        return await this.handleVoidResponse(response);
    }
}
